<template lang="html">
  <div>
    <label class="gray--text">{{label}}{{this.required !== undefined ? '*' : ''}}</label>
    <p class="black--text body-1" :align="align">{{value}}</p>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'align', 'required']
  }
</script>



// WEBPACK FOOTER //
// c-readonly-field.vue?7c0e7a03